export default "__VITE_ASSET__GMnf98wq__"